import { GUESTPRO_URL, waLink, IMAGES } from "@/lib/site";

const ROOMS = [
  {
    img: IMAGES.room3,
    alt: "Standard Room at Raffiel Nias, Sorake Beach",
    tag: "Best Value",
    name: "Standard Room",
    price: "From $45 / night",
    desc: "Simple, spotless room steps from the pool and reef path. King or twin beds, air conditioning, hot shower, Starlink WiFi and daily housekeeping.",
    chips: ["Hot Shower", "Starlink WiFi", "Aircon"],
    cta: "Select on GuestPro",
    href: GUESTPRO_URL,
    testid: "room-card-standard",
  },
  {
    img: IMAGES.room1,
    alt: "Ocean View Deluxe Room at Raffiel Nias with balcony facing the sea",
    tag: "Ocean View",
    name: "Ocean View Deluxe",
    price: "From $60 / night",
    desc: "Bright room facing the break with private balcony, king or twin bed, en-suite hot shower, Starlink WiFi, toiletries and daily housekeeping.",
    chips: ["Ocean Balcony", "Starlink WiFi", "Hot Shower"],
    cta: "Select on GuestPro",
    href: GUESTPRO_URL,
    testid: "room-card-deluxe",
  },
  {
    img: IMAGES.room2,
    alt: "Two Bedroom Ocean View Apartment at Raffiel Nias",
    tag: "Families & Long Stay",
    name: "Two Bedroom Apartment",
    price: "From $130 / night",
    desc: "Ocean view apartment for 3 people with mini kitchen, water dispenser, flat screen TV and workspace — ideal for families, groups and monthly stays from $700.",
    chips: ["Mini Kitchen", "Sleeps 3", "Monthly Rate"],
    cta: "Enquire Monthly Stay",
    href: waLink("Hello Raffiel Nias, I'd like to enquire about a monthly stay in the Two Bedroom Apartment."),
    testid: "room-card-apartment",
  },
];

const Rooms = () => (
  <section id="rooms" className="py-24 bg-sand-50" data-testid="rooms-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
        <div>
          <span className="text-xs font-mono-clean text-terracotta uppercase tracking-wider font-semibold">
            Accommodation
          </span>
          <h2 className="font-display text-3xl sm:text-4xl text-ocean-900 font-bold mt-2">
            Rooms & ocean view apartments
          </h2>
          <p className="text-sm text-fog mt-2 max-w-xl">
            Equipped with hot showers, reliable air conditioning, working desks,
            and clean balcony outlooks for solo surfers, remote creators, and
            traveling groups.
          </p>
        </div>
        <div className="mt-4 md:mt-0">
          <a
            href={GUESTPRO_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="rooms-guestpro-calendar-link"
            className="inline-flex items-center text-sm font-semibold text-ocean-700 hover:underline gap-1"
          >
            Check calendar on GuestPro <span>&rarr;</span>
          </a>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {ROOMS.map((r) => (
          <div
            key={r.name}
            data-testid={r.testid}
            className="bg-white rounded-2xl overflow-hidden border border-sand-200 flex flex-col h-full shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="aspect-[4/3] relative">
              <img src={r.img} alt={r.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
              <span className="absolute bottom-4 left-4 bg-sand-50/90 backdrop-blur text-ocean-900 text-xs font-mono-clean font-semibold px-2.5 py-1 rounded">
                {r.tag}
              </span>
            </div>
            <div className="p-6 flex flex-col flex-1 justify-between">
              <div>
                <div className="flex items-baseline justify-between mb-2 gap-2">
                  <h3 className="font-display text-xl font-bold text-ocean-900">{r.name}</h3>
                  <span className="font-mono-clean text-sm font-semibold text-ocean-700 whitespace-nowrap">
                    {r.price}
                  </span>
                </div>
                <p className="text-xs text-fog leading-relaxed mb-4">{r.desc}</p>
                <div className="flex flex-wrap gap-2 text-[11px] font-mono-clean text-fog mb-6">
                  {r.chips.map((c) => (
                    <span key={c} className="bg-sand-50 px-2 py-1 rounded border border-sand-200">
                      {c}
                    </span>
                  ))}
                </div>
              </div>
              <a
                href={r.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`${r.testid}-cta`}
                className="w-full text-center py-2.5 rounded-lg bg-sand-50 border border-sand-200 hover:bg-ocean-700 hover:text-white hover:border-ocean-700 text-xs font-semibold text-ocean-900 transition-colors"
              >
                {r.cta}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Rooms;
